<template>
  <div id="app1" style="overflow:auto;height:100%">
    <el-button style="position: absolute;top: 20px;right: 432px;" class="print-btn" type="primary" @click="print">打印</el-button>
    <!--startprint-->
    <div id="print" style="width: 900px;margin: 0 auto;background: white;margin-bottom: 30px;margin-top: 20px;">
      <h3 style="text-align:center;margin-bottom:40px;">{{printForm.hospitalName+'会诊咨询意见书'}}</h3>
      <div class="form-body">
        <div style="overflow: hidden;margin-bottom:20px;">
          <div style="margin-left:32px;overflow:hidden;width: 300px;float: left;">
            <p style="width: 100px;float: left;">姓名:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 165px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.name }}
              </p>
            <!-- <p style="float: left;"><input style="width:165px;height: 22px;outline: none;font-size: 16px;" type="text" name="" id="" v-model="printForm.name" disabled></p> -->
          </div>
          <div style="margin-left: 32px;overflow: hidden;width: 200px;float: left;">
            <p style="width: 80px;float: left;">性别:</p>
            <p style="float: left;width: 90px;">
              <input type="radio" name="1" id="" :checked="man" disabled>男
              <input type="radio" name="1" id="" :checked="woman" disabled>女
            </p>
          </div>
          <div style="overflow: hidden;width: 300px;float: left;margin-left: 32px;">
            <p style="width: 100px;float: left;">年龄:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 165px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.age }}
              </p>
            <!-- <p style="float:left;"><input style="width:165px;height: 22px;outline: none;font-size: 16px;" type="text" name="" id="" v-model="printForm.age" ></p> -->
          </div>
        </div>
        <div style="overflow: hidden;margin-bottom:20px;">
          <div style="width: 390px;overflow: hidden;float: left;margin-left: 32px;">
            <p style="width: 100px;float: left;">申请医院:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.applyHospital }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.applyHospital" ></p> -->
          </div>
          <div style="width: 390px;overflow: hidden;float: left;margin-left: 88px;">
            <p style="width: 100px;float: left;">申请医生:</p>
           
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.applyDoctor }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.applyDoctor" ></p> -->
          </div>
        </div>

        <div style="overflow: hidden;margin-bottom:20px;">

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 32px;">
            <p style="width: 100px;float: left;">申请时间:</p>
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.createdTime }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.createdTime" ></p> -->
          </div>

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 88px;">
            <p style="width: 100px;float: left;">会诊时间:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.diagnosisDate }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.diagnosisDate" ></p> -->
          </div>

        </div>

        <div style="overflow: hidden;margin-bottom:20px;">

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 32px;">
            <p style="width: 100px;float: left;">邀请医院:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.invitationHospital }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.invitationHospital" ></p> -->
          </div>

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 88px;">
            <p style="width: 100px;float: left;">邀请医生:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.invitationDoctor }}
              </p>
            <!-- <p style="float: left;"><input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id="" v-model="printForm.invitationDoctor" ></p> -->
          </div>

        </div>

        <div style="overflow: hidden;margin-bottom:20px;">

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 32px;">
            <p style="width: 100px;float: left;">会诊医院:</p>
            
              <p style="float: left;border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.diagnosisHospital }}
              </p>
              <!-- <input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" type="text" name="" id=""
               v-model="printForm.diagnosisHospital" > -->
            
          </div>

          <div style="width: 390px;overflow: hidden;float: left;margin-left: 88px;">
            <p style="width: 100px;float: left;">会诊医生:</p>
              <p style="float: left; border: 1px solid rgb(133, 133, 133);width: 250px;height: 22px;outline: none;ont-size: 16px;" >
                {{ printForm.diagnosisDoctor }}
              </p>
              <!-- <input style="width: 250px;height: 22px;outline: none;ont-size: 16px;" 
              type="text" name="" id="" v-model="printForm.diagnosisDoctor" > -->
          </div>

        </div>

        <div style="overflow: hidden;margin-bottom:20px;">
          <p style="width: 100px;float: left;margin-left: 32px;">患者病情:</p>
          <div style="border: 1px solid rgb(133, 133, 133);float: left;width: 726px;font-size: 16px;height: 145px;" >
            {{ printForm.firstDiagnosis }}
          </div>
          <!-- <textarea style="float: left;width: 726px;font-size: 16px;height: 145px;" name="" id="" cols="30" rows="10" v-model="printForm.firstDiagnosis" ></textarea> -->
        </div>

        <div style="overflow: hidden;margin-bottom:20px;">
          <p style="width: 100px;float: left;margin-left: 32px;" class="lbel-name marginLeft30px">会诊原因:</p>
          <div style="border: 1px solid rgb(133, 133, 133);float: left;width: 726px;font-size: 16px;height: 145px;" >
            {{ printForm.illnessRemark }}
          </div>
          <!-- <textarea style="float: left;width: 726px;font-size: 16px;height: 145px;" name="" id="" cols="30" rows="10" v-model="printForm.illnessRemark" ></textarea> -->
        </div>

        <div style="overflow: hidden;margin-bottom:20px;">
          <p  style="width: 100px;float: left;margin-left: 32px;">会诊医生意见及建议:</p>
          <div style="border: 1px solid rgb(133, 133, 133);float: left;width: 726px;font-size: 16px;min-height: 145px;" >
            {{ printForm.records }}
          </div>
          <!-- <textarea style="float: left;width: 726px;font-size: 16px;height: 145px;" 
          name="" id="" cols="30" rows="10" v-model="printForm.records" ></textarea> -->
        </div>

        <div style="overflow: hidden;margin-bottom:20px;">
          <p  style="width: 100px;float: left;margin-left: 32px;">会诊医生签名及日期:</p>
          
          <div style="border: 1px solid rgb(133, 133, 133);float: left;width: 726px;font-size: 16px;min-height: 80px;" >
          <img v-if="printForm.imgBase64" :src="'data:image/gif;base64,' + printForm.imgBase64" style="float: right;"/>
          </div>
          <!-- <textarea style="float: left;width: 726px;font-size: 16px;height: 45px;" name="" id="" cols="30" rows="10"></textarea> -->
          <div style="clear:both"></div>
          <p style="text-align: right;padding-right: 52px;">{{printForm.year}}&emsp;年&emsp;{{printForm.month}}&emsp;月&emsp;{{printForm.day}}&emsp;日</p>
        </div>

        <div style="overflow: hidden;margin-bottom:20px;">
          <p style="width: 100px;float: left;margin-left: 32px;">备注:</p>
          <textarea style="float: left;width: 726px;font-size: 16px;height: 45px;" name="" id="" cols="30" rows="10"></textarea>
        </div>

      </div>
    </div>
    <!--endprint-->
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      id: '',
      man: '',
      woman: '',
      printForm: {
        name: '',
        sex: '',
        age: '',
        applyHospital: '',
        applyDoctor: '',
        createdTime: '', //申请时间
        diagnosisDate: '', //会诊时间
        invitationHospital: '',
        invitationDoctor: '',
        diagnosisHospital: '', //会诊医院
        diagnosisDoctor: '', //会诊医生
        firstDiagnosis: '', //患者病情
        illnessRemark: '', //会诊原因
        records: '' //建议
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.preview()
    // console.log(this.id)
  },
  methods: {
    print() {
      // console.log(111)

      // var printDtd = $.Deferred()
      // $('#print').print()

      // $.when(printDtd)
      // .done(function() {
      //     // confirm("是否打印成功？");
      //     window.print()
      // });
      // printJS({printable: 'print',type:'html',css:'../../style/print.css'})
      // window.print()

      // let bdhtml = window.document.body.innerHTML
      // let sprnstr = '<!--startprint-->'
      // let eprnstr = '<!--endprint-->'
      // let prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 17)
      //  prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr))
      // window.document.body.innerHTML = prnhtml
      // window.print()


      $("#print").printArea(); 

    },
    preview() {
      this.Axios.get('/api/Remote/GetPrintInfo?id=' + this.id)
        .then(res => {
          let data = res.data.data
          this.printForm = data
          this.printForm.createdTime = moment(
            this.printForm.createdTime
          ).format('YYYY-MM-DD HH:mm') //YYYY-MM-DD HH:mm
          this.printForm.diagnosisDate = moment(
            this.printForm.diagnosisDate
          ).format('YYYY-MM-DD HH:mm') //YYYY-MM-DD HH:mm
          if (data.sex == 1) {
            this.man = true
          } else {
            this.woman = true
          }
          let date = new Date()
          this.printForm.year=date.getFullYear()
          this.printForm.month=date.getMonth()+1
          this.printForm.day=date.getDate()
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
/* @import '../../style/print.css'; */
textarea:disabled, input:disabled  {
  background-color: transparent;
}
@media print {
  textarea:disabled, input:disabled  {
    background-color: transparent;
  }
}

</style>





// WEBPACK FOOTER //
// src/page/print/Print.vue